export enum FeedType {
  IN = 'IN',

  OUT = 'OUT',
}
